import React, { type FC, memo, forwardRef, type RefObject } from 'react';
import { type GeneralFieldProps } from '../../../types/Field';
import { FieldName } from '../../../types/CardFieldName';
import { DH } from '../../../utils/DataHook';
import { t } from '../../../utils/i18n';
import { FieldErrorMessage } from '../../FieldErrorMessage';
import { FieldInput } from '../../FieldInput';
import { FieldLabel } from '../../FieldLabel';

export type CardPostalCodeProps = GeneralFieldProps;

export const CardPostalCode: FC<CardPostalCodeProps> = memo(
  forwardRef((props: CardPostalCodeProps, ref: RefObject<HTMLInputElement>) => {
    const {
      value,
      isValid,
      isTouched,

      onChange,
      onBlur,
      onFocus,
      onLabelClick,
    } = props;

    return (
      <div data-hook={DH.Field.Container.ZipCode}>
        <FieldLabel fieldName={FieldName.PostalCode} text={t('card.postalCode')} onClick={onLabelClick} />
        <FieldInput
          customInput
          fieldName={FieldName.PostalCode}
          type="text"
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          value={value}
          isValid={isValid}
          isTouched={isTouched}
          required
          ref={ref}
        />
        {isTouched && !isValid && <FieldErrorMessage fieldName={FieldName.PostalCode} />}
      </div>
    );
  }),
);
CardPostalCode.displayName = 'CardPostalCode';
